import { RestService, API, getPath } from './lib';
import getSearchServiceImpl from './search/searchServiceDiscovery';
import { SEARCH_SERVICE_TYPE, LEGO_CONSTANTS } from 'constants/index';
import { shouldUseTypeBasedEntityApi } from 'utils/entityIdentifier';

class EntityService extends RestService {
  get = (ids = {}, params = {}) => {
    this.validate(['id'], ids);
    return this.dispatch('ENTITY_GET', ids, params);
  };

  getAll = (ids = {}, params = {}) => {
    return this.dispatch('ENTITY_LIST', ids, params);
  };

  // Always hits v2/entities directly, independent of useTypeBasedApi - used by the useDataSourceApi-gated
  // lookup relationship target dropdown, which needs the v2/entities list regardless of that flag.
  getAllV2 = (ids = {}, params = {}) => {
    const url = getPath(`${LEGO_CONSTANTS.COUI_API_PREFIX}/${LEGO_CONSTANTS.COUI_API_V2_ENTITIES_PATH}`, ids, params);
    return this.sendRequest(url);
  };

  // Always hits v2/entities/search directly, independent of useTypeBasedApi - used by the useDataSourceApi-gated
  // lookup relationship target picker's live search (custom-entity results). When useTypeBasedApi is on, adds
  // search_field=title so the backend matches against the entity's title (its display field in that mode)
  // instead of name.
  searchV2 = (term, ids = {}, params = {}) => {
    const url = getPath(`${LEGO_CONSTANTS.COUI_API_PREFIX}/${LEGO_CONSTANTS.COUI_API_V2_ENTITIES_PATH}/search`, ids, {
      term,
      ...(shouldUseTypeBasedEntityApi() ? { search_field: 'title' } : {}),
      ...params,
    });
    return this.sendRequest(url);
  };

  count = (ids = {}, params = {}) => {
    delete params.sort_by;
    delete params.page_size;
    return this.dispatch('ENTITY_COUNT', ids, params);
  };

  put = (ids = {}, payload = {}, params = {}) => {
    this.validate(['id'], ids);
    return this.dispatch('ENTITY_PUT', ids, params, payload);
  };

  create = (ids = {}, payload = {}, params = {}) => {
    return this.dispatch('ENTITY_CREATE', ids, params, payload);
  };

  delete = (ids = {}, params = {}) => {
    this.validate(['id'], ids);
    return this.dispatch('ENTITY_DELETE', ids, params);
  };

  native = (ids = {}, params = {}) => {
    return this.dispatch('ENTITY_NATIVE', ids, params);
  };

  customisedWidgets = (ids = {}, params = {}) => {
    this.validate(['id'], ids);
    const url = getPath(API.ENTITY_CUSTOMISED_WIDGETS, ids, params);
    return this.sendRequest(url);
  };

  saveCustomisedWidgets = (ids = {}, payload = {}, params = {}) => {
    this.validate(['id'], ids);
    const url = getPath(API.ENTITY_CUSTOMISED_WIDGETS, ids, params);
    return this.sendRequest(url, 'PUT', payload);
  };

  search = (ids = {}, params = {}) => {
    return getSearchServiceImpl(SEARCH_SERVICE_TYPE.ENTITY).search(ids, params);
  };
}

export const entityService = new EntityService();
